// extracted by mini-css-extract-plugin
export default {"input":"AddClassworkPerformanceForm_input__P0VBU","del":"AddClassworkPerformanceForm_del__-wBXT"};